module.exports = __webpack_public_path__ + "img/timeLapseImg1.e5e7f590.png";